import { render, staticRenderFns } from "./el-tips.vue?vue&type=template&id=41e01c82&scoped=true"
import script from "./el-tips.vue?vue&type=script&lang=js"
export * from "./el-tips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e01c82",
  null
  
)

export default component.exports